import { useEffect, useState } from 'react';
import styles from './Callback.module.css';
import { Lock } from 'lucide-react';
import { isValidRedirectUrl } from '../../utils/security';

export default function Callback() {

    const [connected, setConnected] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectTo = urlParams.get('redirectTo');

        if (redirectTo && isValidRedirectUrl(redirectTo)) {
            window.location.href = redirectTo;
            const connectedTimer = setTimeout(() => {
                setConnected(true);
            }, 1500);
            return () => clearTimeout(connectedTimer);
        } else if (redirectTo) {
            // Invalid redirect URL - log warning and don't redirect
            console.error('Invalid redirect URL blocked:', redirectTo);
        }
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.icon}>
                    <Lock size={40} />
                </div>
                {!connected ? (
                    <>
                        <h1 className={styles.title}>Connecting you to the requested app...</h1>
                        <p className={styles.description}>
                            Please wait while we securely pass you to the application you asked to connect.
                        </p>
                        <div className={styles.loader}></div>
                    </>
                ) : (
                    <>
                        <h1 className={styles.title}>You have been connected!</h1>
                        <p className={styles.description}>
                            You may now close this page.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}
